/**
 * @file Level banner phrases loaded from the editable root-level markdown file.
 */

import levelNamesMarkdown from '../../level_names.md?raw';

const FALLBACK_LEVEL_NAMES = Object.freeze(['Kill, Kill, Kill!']);

/**
 * Reads a simple markdown line list. Blank lines and comments are ignored, and
 * optional wrapping quotes are stripped so the source file stays pleasant to edit.
 *
 * @param {string} markdown Raw level_names.md contents.
 * @returns {string[]} Usable banner phrases.
 */
export function parseLevelNames(markdown) {
  return String(markdown ?? '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line && !line.startsWith('#'))
    .map((line) => line.replace(/^["'](.+)["']$/, '$1'))
    .filter(Boolean);
}

export const LEVEL_NAMES = Object.freeze(parseLevelNames(levelNamesMarkdown));

/**
 * @param {() => number} [random] Random number source, 0 inclusive to 1 exclusive.
 * @param {readonly string[]} [names] Phrase pool.
 * @returns {string} A level banner phrase.
 */
export function getRandomLevelName(random = Math.random, names = LEVEL_NAMES) {
  const pool = names.length > 0 ? names : FALLBACK_LEVEL_NAMES;
  const index = Math.min(pool.length - 1, Math.max(0, Math.floor(random() * pool.length)));
  return pool[index];
}
